// extracted by mini-css-extract-plugin
module.exports = {"video":"Video--video--1oVeG","placeholderAnim":"Video--placeholderAnim--2-cnc"};